module.exports = __webpack_public_path__ + "img/activity_num.bbef9a3d.png";